import { useContext, useMemo } from "react";
import { getUserInfo } from "@/lib/storeManager";
import { UserContext } from "./UserContext";

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }

  const user = useMemo(() => {
    const info = getUserInfo() as Record<string, unknown> | null;
    if (!info) return null;
    const id = info.id ?? info.user_id;
    return {
      ...info,
      id: id != null ? String(id) : undefined,
    };
  }, [context.jwtToken, context.decodedToken]);

  return {
    ...context,
    user,
  };
}
